import OtherProduct from '../../../../model/product/other-product/other-product';
import ProductPlacement from '../../../../model/product/product-placement';
import OtherProductPlacement from '../../../../model/product/other-product/other-product-placement';
import ProductFactory from '../../product-factory';
import OtherProductCreationParameters from './other-product-creation-parameters';

export default class OtherProductFactory extends ProductFactory<
  OtherProductCreationParameters
> {
  protected createProductTemplate(parameters: OtherProductCreationParameters) {
    return new OtherProduct();
  }

  protected createProductPlacement(): ProductPlacement {
    const toReturn = new OtherProductPlacement();
    toReturn.productPlacementType = 'OtherProductPlacement';
    return toReturn;
  }

  getProductCreationParameters(
    parameters: any
  ): OtherProductCreationParameters {
    return null;
  }
}
